import { Form, Formik } from 'formik';
import React from 'react';

import SwitchField from '@components/Form/SwitchField';
import useEventTracking from '@hooks/useEventTracking';
import { Page, TrackingLocation } from '@tracking';
import { Newsletter } from '@utils/backend-api/newsletters';

import SignupForm from './SignupForm';

interface NewslettersSignupProps {
  newsletters: Newsletter[];
}

const getInitialValues = (newsletters: Newsletter[]): Record<string, boolean> => {
  return newsletters.reduce(
    (newsletterFields, newsletter) => {
      newsletterFields[newsletter.id.toString()] = true;
      return newsletterFields;
    },
    {} as Record<string, boolean>
  );
};

const NewslettersSignup = ({ newsletters }: NewslettersSignupProps) => {
  useEventTracking({
    page: Page.TITV,
    location: TrackingLocation.NewslettersSignup,
  });

  return (
    <aside
      className="mt-64 flex justify-center bg-grayscale-beige px-16 py-64"
      data-testid="titv-newsletters-signup"
    >
      <div className="m-auto max-w-container-lg">
        <div className="flex flex-col">
          <h3 className="mb-32 mt-0 font-suisse-screen text-headline-xxs text-grayscale-charcoal sm:text-headline-lg">
            Sign up for newsletters
          </h3>
          <div>
            <Formik initialValues={getInitialValues(newsletters)} onSubmit={() => {}}>
              {() => (
                <>
                  <Form>
                    <div className="gird-cols-1 grid gap-48 sm:grid-cols-2 lg:grid-cols-4">
                      {newsletters.map((newsletter) => {
                        return (
                          <div key={newsletter.id} className="flex max-w-[275px] flex-col">
                            <div className="font-suisse-intl-mono text-button-xs text-primary-magenta">
                              {newsletter.frequency}
                              {newsletter.isSubscriberOnly ? (
                                <>
                                  {' '}
                                  <span className="text-grayscale-charcoal">(Subscriber Only)</span>
                                </>
                              ) : null}
                            </div>
                            <div className="font-suisse-neue text-subheadline-sm text-grayscale-charcoal">
                              {newsletter.name}
                            </div>
                            <div className="font-suisse-screen text-byline-sm text-grayscale-charcoal">
                              By {newsletter.author}
                            </div>
                            <div className="min-h-fit font-suisse-intl text-button-md sm:min-h-[120px]">
                              {newsletter?.description}
                            </div>
                            <SwitchField name={newsletter.id.toString()} className="mt-4" />
                          </div>
                        );
                      })}
                    </div>
                  </Form>
                  <SignupForm />
                </>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default NewslettersSignup;
